export const POST_TEAM_HOURS = '/team_hours';
export const GET_TEAM_HOURS = (id, year, month) =>
  `/team_hours/${id}/${year}/${month}/`;
